import React, { useEffect } from "react";
import BlogSection from "../components/Home/BlogSection";
import ExpertiseSection from "../components/Home/ExpertiseSection";
import Hero from "../components/Home/Hero";
import HomeClients from "../components/Home/HomeClients";
import HomeContact from "../components/Home/HomeContact";
import StepSection from "../components/Home/StepSection";
import Testimonial from "../components/Home/Testmonial";
import Welcome from "../components/Home/Welcome";
const HomePage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <title>Truviq System</title>
      <Hero />
      <Welcome />
      <ExpertiseSection />
      <StepSection />
      <HomeClients />
      <Testimonial />
      <BlogSection />
      <HomeContact />
    </>
  );
};

export default HomePage;
